import '.c4{position:relative;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.hh{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.bs{align-items:flex-start;}.ssr-plugin'
import '.a2{padding:2rem;}.ssr-plugin'
import '.c7{background:var(--palette-white);}.ssr-plugin'
import '.ag{overflow:hidden;}.ssr-plugin'
import '.b4{position:absolute;}.ssr-plugin'
import '.ji{top:50%;}.ssr-plugin'
import '.jj{right:1rem;}.ssr-plugin'
import '.jk{transform:translateY(-50%);}.ssr-plugin'
import '.jl{width:120px;}.ssr-plugin'
import '.jm{height:120px;}.ssr-plugin'
import '.jn{z-index:0;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.iq{z-index:1;}.ssr-plugin'
import '.ap{gap:0.5rem;}.ssr-plugin'
import '.jo{max-width:calc(100% - 140px);}.ssr-plugin'
import '.jp{font-size:4rem;}.ssr-plugin'
import '.dg{font-weight:700;}.ssr-plugin'
import '.jq{line-height:100%;}.ssr-plugin'
import '.ge{margin:0px;}.ssr-plugin'
import '.a5{color:var(--brand-secondary);}.ssr-plugin'
import '.a6{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c4 a0 hh a b i bs a2 c7 ag"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="b4 ji jj jk jl jm jn a c i"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c4 iq a b bs ap jo"
      >
        <div className="jp dg jq ge a5 a6"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
